<template>
  <div class="container page setbank-page">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar bank-nav">
      <template #left>
        <van-icon name="arrow-left" class="nav-back" @click="back()"/>
      </template>
    </van-nav-bar>

    <div class="page-body">
      <div v-if="is_bind" class="bank-card">
        <div class="bank-name">{{ this.bankInfo.bankinfo }}</div>
        <div class="bank-user">{{ this.bankInfo.username }}</div>
        <div class="bank-number">{{ this.bankInfo.bankid }}</div>
        <div class="bank-status">{{$t("setting.bindinged")}}</div>
      </div>

      <div v-else class="add-card" @click="toBindCard()">
        <van-icon name="plus" />
        <span>{{$t("setting.add_bank")}}</span>
      </div>

      <div class="tips">{{$t("setting.bind_bank_tip")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;this.$router.push({path:'/BindCard'});
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("Setname");
        this.$toast(this.$t("setting.set_name_bank"));
        return true;
      } else if (!this.userInfo.paypassword) {
        
        // this.$router.push("SetPayPassword");
        this.$router.push({path:'/BindCard'})
        // this.$toast(this.$t("setting.set_pwd_bank"));
        return true;
      } else {
        this.$router.push({path:'/BindCard'})
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.setbank-page {
  min-height: 100%;
  background: #f5f5f5;
}

.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.page-body {
  padding: 16px;
}

.bank-card {
  position: relative;
  min-height: 250px;
  padding: 36px 36px 44px;
  border-radius: 20px;
  background: linear-gradient(90deg, #6667e8 0%, #5d63e1 100%);
  color: #fff;
}

.bank-name {
  font-size: 28px;
  line-height: 40px;
}

.bank-user {
  margin-top: 20px;
  font-size: 28px;
  line-height: 40px;
}

.bank-number {
  margin-top: 28px;
  font-size: 34px;
  line-height: 48px;
  word-break: break-all;
}

.bank-status {
  position: absolute;
  right: 30px;
  bottom: 26px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 24px;
  line-height: 34px;
}

.add-card{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  background-color: #fff;
  height: 250px;
  border-radius: 18px;
}
.add-card span{
  margin-left: 10px;
  font-size: 30px;
}
.tips {
  margin: 22px 6px 0;
  font-size: 25px;
  color: #979799;
}

::v-deep .bank-nav {
  background: #fff;
}

::v-deep .bank-nav .van-nav-bar__title {
  color: #000;
  font-weight: 500;
}

::v-deep .bank-nav::after {
  border-bottom: 1px solid #ededed;
}

.nav-back {
  color: #8795ad;
}
</style>
